import axios from "axios";

// get the respondent details based on the respondent uuid
export function getRespondentDetails({ uuid }) {
  return new Promise((resolve, reject) => {
    axios.get(`/consumer/admin/api/v1/survey-respondent/${uuid}`)
      .then(response => resolve(response.data))
      .catch(error => reject(error.response.data))
  })
}